export const routes = {
  home: "/home",
  login: "/login",
  registration: "/registration",
  active: "/active",
  setting: "/setting",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  overview: "/overview",
  transactions: "/transactions",
  budgets: "/budgets",
  add_wallet: "/add-wallet",
  wallets: "/wallets",
  dashboard: "/dashboard",
  walletInfo: "/wallets/:walletId",
  ip: "/ip",
  terms: "/terms",
  help: "/help",
};
